export default "__VITE_ASSET__BJ4JezH6__"